module.exports = __webpack_public_path__ + "67d5c6fd712d258bc346e2b55b612fdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1_variable/public/news/temp.jpg
// module id = 427
// module chunks = 0